// extracted by mini-css-extract-plugin
export default {"ohHovertab":"style_ohHovertab__9JjyL","onSelectedtab":"style_onSelectedtab__-S7RC","numberAvatar":"style_numberAvatar__2CUPO","textAvatar":"style_textAvatar__m7uys"};